import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37f0286f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "database-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "数据库链接", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, [
  /*#__PURE__*/_createTextVNode(" 外置数据库操作, 请先处理好数据库连通, 然后新建一个'smanga'的数据库, 测试链接方可成功. 之后请手动导入sql文件. 如不使用外置数据库则不需要设置此项. "),
  /*#__PURE__*/_createElementVNode("a", { href: "/file/smanga.sql" }, "数据库导入文件")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode(_component_el_form, {
      model: $setup.form,
      inline: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "database:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.database,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.database) = $event)),
              style: {"width":"28rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "ip:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.ip,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.ip) = $event)),
              style: {"width":"16rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "端口:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.port,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.port) = $event)),
              style: {"width":"9rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "用户名:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.userName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.userName) = $event)),
              style: {"width":"11rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { label: "密码:" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: $setup.form.passWord,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.passWord) = $event)),
              style: {"width":"11rem"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model"]),
    _createElementVNode("div", _hoisted_5, [
      _createCommentVNode(" <el-button type=\"success\" @click=\"check\">测试链接</el-button> "),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: $setup.setting
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认修改")
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}